export const nodesEs: Record<string, string> = {
  'action_0_0': '+5% de aumento en el daño de acción',
  'action_0_1': '+5% de probabilidad de que la acción cause el doble de daño',
  'action_0_2': '+12% de aumento en el daño de acción',
  'action_0_3': '+5% de aumento en el daño de acción',
  'action_0_4': '+5% de probabilidad de que la acción cause el doble de daño',
  'action_0_5': '+20% más de daño de acción',
  'action_0_6': '+5% de aumento en el daño de acción',
  'action_0_7': '+5% de probabilidad de que la acción cause el doble de daño',
  'action_0_8': '+5% de probabilidad de que la acción cause el doble de daño · +5% de aumento en el daño de acción · +5% de aumento en la velocidad de acción',
  'action_0_9': '+5% de aumento en el daño de acción',
  'action_0_10': '+5% de probabilidad de que la acción cause el doble de daño',
  'action_0_11': 'Los impactos de acción tienen 20% más de probabilidad de ignorar toda la mitigación de daño enemiga',
  'action_0_12': '+10% más de daño de acción · 6% menos de velocidad de acción',
  'action_0_13': '+10% más de daño de acción · +20% más de costo de maná de acción',
  'action_0_14': '+15% de aumento en la probabilidad de que una acción cause el doble de daño',
  'action_0_15': '+10% más de daño de acción',

  'action_1_0': '+4% de aumento en la velocidad de acción',
  'action_1_1': '+3% de aumento en la probabilidad de que la acción se repita',
  'action_1_2': '+10% de aumento en la velocidad de acción',
  'action_1_3': '+4% de aumento en la velocidad de acción',
  'action_1_4': '+3% de aumento en la probabilidad de que la acción se repita',
  'action_1_5': '+20% más de velocidad de acción',
  'action_1_6': '+4% de aumento en la velocidad de acción',
  'action_1_7': '+3% de aumento en la probabilidad de que la acción se repita',
  'action_1_8': '+4% de aumento en la velocidad de acción · +3% de aumento en la probabilidad de que la acción se repita · +5% de aumento en el daño de acción',
  'action_1_9': '+4% de aumento en la velocidad de acción',
  'action_1_10': '+3% de aumento en la probabilidad de que la acción se repita',
  'action_1_11': 'Al repetir una acción, el segundo impacto inicial activa las aflicciones de forma garantizada',
  'action_1_12': '+10% más de velocidad de acción · 10% menos de daño de acción',
  'action_1_13': '+5% de aumento en la probabilidad de que la acción se repita',
  'action_1_14': 'Las acciones dobles vuelven a tirar una vez para repetirse de nuevo',
  'action_1_15': 'No hay acciones dobles; la probabilidad de acción doble se convierte en probabilidad de daño doble',

  'action_2_0': 'Las acciones tienen +2% de probabilidad de activar el Trance',
  'action_2_1': 'Acciones en Trance: +5% de probabilidad de apuntar a un enemigo adicional · +5% de aumento en el daño · +5% de aumento en la velocidad de acción',
  'action_2_2': 'Las acciones tienen +5% de probabilidad de activar el Trance',
  'action_2_3': 'Las acciones tienen +2% de probabilidad de activar el Trance',
  'action_2_4': 'Acciones en Trance: +5% de probabilidad de apuntar a un enemigo adicional · +5% de aumento en el daño · +5% de aumento en la velocidad de acción',
  'action_2_5': 'Las acciones tienen +3% de probabilidad de activar el Trance · Acciones en Trance: +8% de probabilidad de apuntar a un enemigo adicional · +8% de aumento en el daño · +8% de aumento en la velocidad de acción',
  'action_2_12': 'El Trance puede acumularse una vez consigo mismo · Duración del Trance reducida a la mitad',
  'action_2_13': 'Las acciones tienen +5% de probabilidad de activar el Trance',

  'action_3_0': '+10% de reducción en el costo de maná de las acciones',
  'action_3_1': '+10% de probabilidad de que las acciones no cuesten maná',
  'action_3_2': 'Las acciones cuestan entre 0 y 33% menos de maná (aleatorio por acción)',
  'action_3_3': '+10% de reducción en el costo de maná de las acciones',
  'action_3_4': '+10% de probabilidad de que las acciones no cuesten maná',
  'action_3_5': '+10% de reducción en el costo de maná de las acciones · +10% de probabilidad de que las acciones no cuesten maná · Las acciones repetidas ignoran el requisito de maná',
  'action_3_12': 'Las reducciones de costo de maná de este árbol aumentan el costo de maná en su lugar · La probabilidad de no costar maná se convierte en probabilidad de costar el doble de maná',
  'action_3_13': '30% menos de costo de maná de acción',

  'criticalHit_0_0': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_1': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_2': '+20% de aumento en el daño de golpe crítico · +10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_0_3': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_4': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_5': 'Los golpes críticos tienen +20% de probabilidad de ignorar toda la mitigación de daño enemiga',
  'criticalHit_0_6': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_7': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_8': '+20% de aumento en el daño de golpe crítico · +10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_0_9': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_10': '+10% de aumento en el daño de golpe crítico',
  'criticalHit_0_11': '+20% más de daño de golpe crítico',
  'criticalHit_0_12': '+10% más de daño de golpe crítico',
  'criticalHit_0_13': '+10% de probabilidad de que los golpes críticos ignoren toda la mitigación de daño enemiga',
  'criticalHit_0_14': 'El bono de daño de golpe crítico de este árbol se aplica al daño de aflicción de los golpes críticos en lugar de los impactos directos',
  'criticalHit_0_15': 'El daño doble se convierte en triple cuando un golpe crítico también obtiene daño doble',

  'criticalHit_1_0': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_1': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_2': '+20% de aumento en la probabilidad de realizar un golpe crítico · +10% de aumento en el daño de golpe crítico',
  'criticalHit_1_3': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_4': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_5': '+3% de probabilidad base de golpe crítico de acción',
  'criticalHit_1_6': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_7': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_8': '+20% de aumento en la probabilidad de realizar un golpe crítico · +10% de aumento en el daño de golpe crítico',
  'criticalHit_1_9': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_10': '+10% de aumento en la probabilidad de realizar un golpe crítico',
  'criticalHit_1_11': '+20% más de probabilidad de realizar un golpe crítico',
  'criticalHit_1_12': '+2% de probabilidad base de golpe crítico de acción',
  'criticalHit_1_13': '+10% más de probabilidad de realizar un golpe crítico',
  'criticalHit_1_14': 'Los golpes críticos aplican una aflicción garantizada · Los golpes críticos no causan daño adicional',
  'criticalHit_1_15': '+20% más de probabilidad de realizar un golpe crítico contra enemigos con alguna aflicción',

  'physical_0_0': '+5% de aumento en el daño físico',
  'physical_0_1': '+3% de aumento en la velocidad de acción física',
  'physical_0_2': '+5% de aumento en el daño físico · Las acciones físicas tienen +5% de probabilidad de aplicar sangrado',
  'physical_0_3': '+5% de aumento en el daño físico',
  'physical_0_4': '+3% de aumento en la velocidad de acción física',
  'physical_0_5': '+10% más de daño físico',
  'physical_0_6': '+5% de aumento en el daño físico',
  'physical_0_7': '+3% de aumento en la velocidad de acción física',
  'physical_0_8': '+12% de aumento en el daño físico',
  'physical_0_9': '+5% de aumento en el daño físico',
  'physical_0_10': '+3% de aumento en la velocidad de acción física',
  'physical_0_11': 'Los enemigos sangrando reciben +10% más de daño físico',

  'physical_1_0': 'Las acciones físicas tienen +5% de probabilidad de aplicar sangrado',
  'physical_1_1': '+15% de aumento en el daño de sangrado',
  'physical_1_2': '+30% de aumento en el daño de sangrado · +10% de aumento en la duración del sangrado',
  'physical_1_3': 'Las acciones físicas tienen +5% de probabilidad de aplicar sangrado',
  'physical_1_4': '+15% de aumento en el daño de sangrado',
  'physical_1_5': '+30% más de daño de sangrado',
  'physical_1_6': 'Las acciones físicas tienen +5% de probabilidad de aplicar sangrado',
  'physical_1_7': '+15% de aumento en el daño de sangrado',
  'physical_1_8': '+60% de aumento en el daño de sangrado',
  'physical_1_9': 'Las acciones físicas tienen +5% de probabilidad de aplicar sangrado',
  'physical_1_10': '+15% de aumento en el daño de sangrado',
  'physical_1_11': 'El sangrado ignora la resistencia física enemiga',
  'physical_1_12': '+30% más de daño de sangrado · Duración del sangrado reducida a la mitad',
  'physical_1_13': 'Duración del sangrado duplicada · 30% menos de daño de sangrado',
  'physical_1_14': 'Daño de sangrado duplicado · No causas daño con impactos',
  'physical_1_15': '+10% más de daño de sangrado',

  'physical_2_0': 'Las acciones físicas tienen +5% de probabilidad de reducir permanentemente la resistencia física y putrefacción del enemigo en 1%',
  'physical_2_1': '+5% de aumento en el daño físico',
  'physical_2_2': 'Las acciones físicas tienen +7% de probabilidad de reducir permanentemente la resistencia física y putrefacción del enemigo en 1% · +3% de aumento en la velocidad de acción física',
  'physical_2_3': 'Las acciones físicas tienen +5% de probabilidad de reducir permanentemente la resistencia física y putrefacción del enemigo en 1%',
  'physical_2_4': '+5% de aumento en el daño físico',
  'physical_2_5': 'Los enemigos con 0% de resistencia física y putrefacción ven su velocidad de acción y movimiento reducida en 20%',

  'physical_3_0': '+5% de probabilidad de activar la Sed de Sangre al infligir sangrado',
  'physical_3_1': 'La Sed de Sangre otorga +5% de aumento en la velocidad de acción física',
  'physical_3_2': 'La Sed de Sangre otorga +5% de aumento en la velocidad de acción física y +12% de aumento en el daño físico · Las acciones físicas durante la Sed de Sangre tienen +10% de probabilidad de causar sangrado',
  'physical_3_3': '+5% de probabilidad de activar la Sed de Sangre al infligir sangrado',
  'physical_3_4': 'La Sed de Sangre otorga +5% de aumento en la velocidad de acción física',
  'physical_3_5': 'La Sed de Sangre otorga +5% de aumento en la velocidad de acción física y +12% de aumento en el daño físico · +25% de aumento en la duración de la Sed de Sangre',

  'fire_0_0': '+5% de aumento en el daño de fuego',
  'fire_0_1': '+3% de aumento en la velocidad de acción de fuego',
  'fire_0_2': '+5% de aumento en el daño de fuego · Las acciones de fuego tienen +5% de probabilidad de aplicar quemadura',
  'fire_0_3': '+5% de aumento en el daño de fuego',
  'fire_0_4': '+3% de aumento en la velocidad de acción de fuego',
  'fire_0_5': '+10% más de daño de fuego',
  'fire_0_6': '+5% de aumento en el daño de fuego',
  'fire_0_7': '+3% de aumento en la velocidad de acción de fuego',
  'fire_0_8': '+12% de aumento en el daño de fuego',
  'fire_0_9': '+5% de aumento en el daño de fuego',
  'fire_0_10': '+3% de aumento en la velocidad de acción de fuego',
  'fire_0_11': 'Los enemigos ardiendo tienen 20% menos de resistencia al fuego',

  'fire_1_0': 'Las acciones de fuego tienen +5% de probabilidad de aplicar quemadura',
  'fire_1_1': '+15% de aumento en el daño de quemadura',
  'fire_1_2': '+30% de aumento en el daño de quemadura · +10% de aumento en la duración de la quemadura',
  'fire_1_3': 'Las acciones de fuego tienen +5% de probabilidad de aplicar quemadura',
  'fire_1_4': '+15% de aumento en el daño de quemadura',
  'fire_1_5': '+30% más de daño de quemadura',
  'fire_1_6': 'Las acciones de fuego tienen +5% de probabilidad de aplicar quemadura',
  'fire_1_7': '+15% de aumento en el daño de quemadura',
  'fire_1_8': 'Los enemigos ardiendo reciben +30% de aumento en el daño de todas las fuentes',
  'fire_1_9': 'Las acciones de fuego tienen +5% de probabilidad de aplicar quemadura',
  'fire_1_10': '+15% de aumento en el daño de quemadura',
  'fire_1_11': 'Los enemigos ardiendo propagan el 50% de su daño de quemadura a los enemigos cercanos que no están ardiendo',
  'fire_1_12': '+30% más de daño de quemadura · Duración de la quemadura reducida a la mitad',
  'fire_1_13': 'Duración de la quemadura duplicada · 30% menos de daño de quemadura',
  'fire_1_14': 'Daño de quemadura duplicado · No causas daño con impactos',
  'fire_1_15': '+10% más de daño de quemadura',

  'fire_2_0': 'Las acciones de fuego tienen +5% de probabilidad de crear suelo en llamas',
  'fire_2_1': '+45% de aumento en el daño del suelo en llamas',
  'fire_2_2': '+90% de aumento en el daño del suelo en llamas · +30% de aumento en la duración del suelo en llamas',
  'fire_2_3': 'Las acciones de fuego tienen +5% de probabilidad de crear suelo en llamas',
  'fire_2_4': '+45% de aumento en el daño del suelo en llamas',
  'fire_2_5': 'El suelo en llamas reduce la velocidad de movimiento y acción de los enemigos en 20% · +30% más de daño del suelo en llamas',

  'fire_3_0': 'Las acciones de fuego tienen +2% de probabilidad de activar la Inmolación',
  'fire_3_1': 'Mientras te inmolas: +5% de aumento en el daño de fuego · +5% de probabilidad de quemar',
  'fire_3_2': 'El daño de auto-quemadura de la Inmolación se reduce a la mitad (×0,5)',
  'fire_3_3': 'Las acciones de fuego tienen +2% de probabilidad de activar la Inmolación',
  'fire_3_4': 'Mientras te inmolas: +5% de aumento en el daño de fuego · +5% de probabilidad de quemar',
  'fire_3_5': 'Las acciones de fuego tienen +5% de probabilidad de activar la Inmolación · Mientras te inmolas: +10% de aumento en el daño de fuego · +10% de probabilidad de quemar · El daño de auto-quemadura de la Inmolación se reduce a la mitad (×0,5)',

  'lightning_0_0': '+5% de aumento en el daño de rayo',
  'lightning_0_1': '+3% de aumento en la velocidad de acción de rayo',
  'lightning_0_2': '+5% de aumento en el daño de rayo · Las acciones de rayo tienen +5% de probabilidad de electrocutar',
  'lightning_0_3': '+5% de aumento en el daño de rayo',
  'lightning_0_4': '+3% de aumento en la velocidad de acción de rayo',
  'lightning_0_5': '+10% más de daño de rayo',
  'lightning_0_6': '+5% de aumento en el daño de rayo',
  'lightning_0_7': '+3% de aumento en la velocidad de acción de rayo',
  'lightning_0_8': '+12% de aumento en el daño de rayo',
  'lightning_0_9': '+5% de aumento en el daño de rayo',
  'lightning_0_10': '+3% de aumento en la velocidad de acción de rayo',
  'lightning_0_11': '+10% más de daño de rayo · +5% más de velocidad de acción de rayo',

  'lightning_1_0': 'Las acciones de rayo tienen +5% de probabilidad de electrocutar',
  'lightning_1_1': '+3% de aumento en el daño recibido por electrocución',
  'lightning_1_2': '+5% de aumento en el daño recibido por electrocución · +10% de aumento en la duración de la electrocución',
  'lightning_1_3': 'Las acciones de rayo tienen +5% de probabilidad de electrocutar',
  'lightning_1_4': '+3% de aumento en el daño recibido por electrocución',
  'lightning_1_5': '+8% de aumento en el daño recibido por electrocución · +20% de aumento en la duración de la electrocución',
  'lightning_1_6': 'Las acciones de rayo tienen +5% de probabilidad de electrocutar',
  'lightning_1_7': '+3% de aumento en el daño recibido por electrocución',
  'lightning_1_8': 'Las acciones de rayo tienen +15% de probabilidad de electrocutar',
  'lightning_1_9': 'Las acciones de rayo tienen +5% de probabilidad de electrocutar',
  'lightning_1_10': '+3% de aumento en el daño recibido por electrocución',
  'lightning_1_11': 'Los enemigos electrocutados ven su velocidad de movimiento y acción reducida por el valor del daño de electrocución recibido',
  'lightning_1_12': '+5% de aumento en el daño recibido por electrocución · 10% menos de duración de la electrocución',
  'lightning_1_13': '20% más de duración de la electrocución',
  'lightning_1_14': 'Las acciones de rayo tienen +5% de probabilidad de saltar desde un enemigo electrocutado',
  'lightning_1_15': '+5% de aumento en el daño recibido por electrocución',

  'lightning_2_0': 'Las acciones de rayo tienen +20% de probabilidad de saltar a un enemigo adicional',
  'lightning_2_1': '+10% de reducción en la penalización de daño del salto',
  'lightning_2_2': 'Las acciones de rayo tienen +30% de probabilidad de saltar a un enemigo adicional · +15% de reducción en la penalización de daño del salto',
  'lightning_2_3': 'Las acciones de rayo tienen +20% de probabilidad de saltar a un enemigo adicional',
  'lightning_2_4': '+10% de reducción en la penalización de daño del salto',
  'lightning_2_5': 'Los saltos exitosos vuelven a tirar para otro salto (cadena ilimitada) · +30% de aumento en el rango de salto',

  'lightning_3_0': 'Las acciones de rayo tienen +5% de probabilidad de Electrificarte',
  'lightning_3_1': '+5% de aumento en la velocidad de acción mientras estás Electrificado',
  'lightning_3_2': '+25% de aumento en la duración de la Electrificación · +5% de aumento en la velocidad de acción mientras estás Electrificado',
  'lightning_3_3': 'Las acciones de rayo tienen +5% de probabilidad de Electrificarte',
  'lightning_3_4': '+5% de aumento en la velocidad de acción mientras estás Electrificado',
  'lightning_3_5': '5% menos de daño recibido de todas las fuentes mientras estás Electrificado',

  'area_0_0': '+5% de aumento en el daño de área',
  'area_0_1': '+5% de probabilidad de que el área cause el doble de daño',
  'area_0_2': '+12% de aumento en el daño de área',
  'area_0_3': '+5% de aumento en el daño de área',
  'area_0_4': '+5% de probabilidad de que el área cause el doble de daño',
  'area_0_5': '+20% más de daño de área',
  'area_0_6': '+5% de aumento en el daño de área',
  'area_0_7': '+5% de probabilidad de que el área cause el doble de daño',
  'area_0_8': '+5% de probabilidad de que el área cause el doble de daño · +5% de aumento en el daño de área · +5% de aumento en el tamaño del área',
  'area_0_9': '+5% de aumento en el daño de área',
  'area_0_10': '+5% de probabilidad de que el área cause el doble de daño',
  'area_0_11': '+30% más de daño de área · 15% menos de velocidad de acción de área',

  'area_1_0': '+5% de aumento en el radio de acción de área',
  'area_1_1': '+5% de aumento en el daño de área',
  'area_1_2': '+12% de aumento en el radio de acción de área',
  'area_1_3': '+5% de aumento en el radio de acción de área',
  'area_1_4': '+5% de aumento en el daño de área',
  'area_1_5': '+15% más de radio de acción de área',
  'area_1_6': '+5% de aumento en el radio de acción de área',
  'area_1_7': '+5% de aumento en el daño de área',
  'area_1_8': '+8% de aumento en el radio de acción de área · +5% de aumento en el daño de área',
  'area_1_9': '+5% de aumento en el radio de acción de área',
  'area_1_10': '+5% de aumento en el daño de área',
  'area_1_11': '+10% más de radio de acción de área · +10% más de daño de área · 10% menos de velocidad de acción de área',

  'area_2_0': 'Las acciones de área tienen +5% de probabilidad de activar un temblor',
  'area_2_1': 'Los temblores causan +5% de aumento en el daño',
  'area_2_2': 'Las acciones de área tienen +8% de probabilidad de activar un temblor · Los temblores tienen +8% de aumento en el radio de área',
  'area_2_3': 'Las acciones de área tienen +5% de probabilidad de activar un temblor',
  'area_2_4': 'Los temblores causan +5% de aumento en el daño',
  'area_2_5': 'Las acciones de área tienen +7% de probabilidad de activar un temblor · Los temblores tienen +7% de aumento en el radio de área · Los temblores causan +7% de aumento en el daño',

  'area_3_0': 'Los impactos de área tienen +10% de probabilidad de empujar al objetivo',
  'area_3_1': 'Los enemigos empujados tienen 10% menos de velocidad de movimiento durante 2 segundos',
  'area_3_2': 'Los impactos de área tienen +15% de probabilidad de empujar al objetivo · +15% de aumento en el daño de área',
  'area_3_3': 'Los impactos de área tienen +10% de probabilidad de empujar al objetivo',
  'area_3_4': 'Los enemigos empujados tienen 10% menos de velocidad de movimiento durante 2 segundos',
  'area_3_5': '+30% más de rango de empuje · Los enemigos empujados causan 10% menos de daño durante 2 segundos',

  'projectile_0_0': '+5% de aumento en el daño de proyectil',
  'projectile_0_1': '+5% de probabilidad de impactar a un objetivo adicional',
  'projectile_0_2': '+12% de aumento en el daño de proyectil',
  'projectile_0_3': '+5% de aumento en el daño de proyectil',
  'projectile_0_4': '+5% de probabilidad de impactar a un objetivo adicional',
  'projectile_0_5': '+20% más de daño de proyectil',
  'projectile_0_6': '+5% de aumento en el daño de proyectil',
  'projectile_0_7': '+5% de probabilidad de impactar a un objetivo adicional',
  'projectile_0_8': '+5% de probabilidad de impactar a un objetivo adicional · +5% de aumento en el daño de proyectil · +5% de aumento en la velocidad de acción',
  'projectile_0_9': '+5% de aumento en el daño de proyectil',
  'projectile_0_10': '+5% de probabilidad de impactar a un objetivo adicional',
  'projectile_0_11': '+20% de probabilidad de causar el doble de daño · +10% de aumento en el rango de proyectiles',

  'projectile_1_0': '+5% de probabilidad de disparar un proyectil adicional con 50% de daño',
  'projectile_1_1': '+5% de aumento en el daño de proyectiles adicionales',
  'projectile_1_2': '+7% de probabilidad de disparar un proyectil adicional · +7% de aumento en el daño de proyectiles adicionales',
  'projectile_1_3': '+5% de probabilidad de disparar un proyectil adicional',
  'projectile_1_4': '+5% de aumento en el daño de proyectiles adicionales',
  'projectile_1_5': '+15% de probabilidad de disparar un proyectil adicional',
  'projectile_1_6': '+5% de probabilidad de disparar un proyectil adicional',
  'projectile_1_7': '+5% de aumento en el daño de proyectiles adicionales',
  'projectile_1_8': '+7% de probabilidad de disparar un proyectil adicional · +7% de aumento en el daño de proyectiles adicionales',
  'projectile_1_9': '+5% de probabilidad de disparar un proyectil adicional',
  'projectile_1_10': '+5% de aumento en el daño de proyectiles adicionales',
  'projectile_1_11': 'Cuando se dispara un proyectil adicional, se tira una vez más para un segundo proyectil adicional',

  'projectile_2_0': '+5% de aumento en el rango de proyectiles',
  'projectile_2_1': '+5% de aumento en el daño de proyectil',
  'projectile_2_2': '+12% de aumento en el rango de proyectiles',
  'projectile_2_3': '+5% de aumento en el rango de proyectiles',
  'projectile_2_4': '+5% de aumento en el daño de proyectil',
  'projectile_2_5': '+5% de aumento en el daño de proyectil por unidad de rango (mínimo 5% a rango 1)',

  'projectile_3_0': 'Los impactos de proyectil tienen +10% de probabilidad de empujar al objetivo',
  'projectile_3_1': 'Los enemigos empujados tienen 10% menos de velocidad de movimiento durante 2 segundos',
  'projectile_3_2': 'Los impactos de proyectil tienen +15% de probabilidad de empujar al objetivo · +15% de aumento en el daño de proyectil',
  'projectile_3_3': 'Los impactos de proyectil tienen +10% de probabilidad de empujar al objetivo',
  'projectile_3_4': 'Los enemigos empujados tienen 10% menos de velocidad de movimiento durante 2 segundos',
  'projectile_3_5': '+30% más de rango de empuje · Los enemigos empujados causan 10% menos de daño durante 2 segundos',

  'strike_0_0': '+5% de aumento en el daño de golpe',
  'strike_0_1': '+5% de probabilidad de que el golpe cause el doble de daño',
  'strike_0_2': '+12% de aumento en el daño de golpe',
  'strike_0_3': '+5% de aumento en el daño de golpe',
  'strike_0_4': '+5% de probabilidad de que el golpe cause el doble de daño',
  'strike_0_5': '+20% más de daño de golpe',
  'strike_0_6': '+5% de aumento en el daño de golpe',
  'strike_0_7': '+5% de probabilidad de que el golpe cause el doble de daño',
  'strike_0_8': '+5% de probabilidad de que el golpe cause el doble de daño · +5% de aumento en el daño de golpe · +5% de aumento en la velocidad de acción',
  'strike_0_9': '+5% de aumento en el daño de golpe',
  'strike_0_10': '+5% de probabilidad de que el golpe cause el doble de daño',
  'strike_0_11': 'Los golpes tienen +20% de probabilidad de activar aflicciones',

  'strike_1_0': 'Los golpes tienen +5% de probabilidad de activar Frenesí',
  'strike_1_1': 'El Frenesí otorga +1% de aumento en el daño y la velocidad de acción por carga',
  'strike_1_2': 'Los golpes tienen +5% de probabilidad de activar Frenesí · El Frenesí otorga un bono fijo de +10% de aumento en el daño y la velocidad de acción',
  'strike_1_3': 'Los golpes tienen +5% de probabilidad de activar Frenesí',
  'strike_1_4': 'El Frenesí otorga +1% de aumento en el daño y la velocidad de acción por carga',
  'strike_1_5': 'El Frenesí tiene +1% de probabilidad de activar aflicciones por carga',
  'strike_1_6': 'Los golpes tienen +5% de probabilidad de activar Frenesí',
  'strike_1_7': 'El Frenesí otorga +1% de aumento en el daño y la velocidad de acción por carga',
  'strike_1_8': 'Los golpes tienen +5% de probabilidad de activar Frenesí · El Frenesí tiene +20% de aumento en la duración · El Frenesí otorga +1% de aumento en el daño y la velocidad de acción por carga',
  'strike_1_9': 'Los golpes tienen +5% de probabilidad de activar Frenesí',
  'strike_1_10': 'El Frenesí otorga +1% de aumento en el daño y la velocidad de acción por carga',
  'strike_1_11': 'El Frenesí tiene 10 cargas máximas adicionales',

  'strike_2_0': '+5% de aumento en el rango de golpe',
  'strike_2_1': '+3% de aumento en la velocidad de acción de golpe',
  'strike_2_2': '+5% de aumento en el rango de golpe · +5% de aumento en el daño de golpe',
  'strike_2_3': '+5% de aumento en el rango de golpe',
  'strike_2_4': '+3% de aumento en la velocidad de acción de golpe',
  'strike_2_5': '+10% más de rango de golpe · +5% más de velocidad de acción de golpe · Los golpes tienen +10% de probabilidad de salpicar',

  'strike_3_0': '+8% de probabilidad de que las acciones de golpe apunten a un enemigo adicional',
  'strike_3_1': '+3% de aumento en la velocidad de acción de golpe',
  'strike_3_2': '+15% de probabilidad de que las acciones de golpe apunten a un enemigo adicional',
  'strike_3_3': '+8% de probabilidad de que las acciones de golpe apunten a un enemigo adicional',
  'strike_3_4': '+3% de aumento en la velocidad de acción de golpe',
  'strike_3_5': '+20% más de probabilidad de que las acciones de golpe apunten a un enemigo adicional · Los golpes tienen +10% de probabilidad de salpicar',

  'life_0_0': '+5% de aumento en la vida máxima',
  'life_0_1': '+5% de resistencia física y putrefacción',
  'life_0_2': '+12% de aumento en la vida máxima',
  'life_0_3': '+5% de aumento en la vida máxima',
  'life_0_4': '+5% de resistencia elemental',
  'life_0_5': '+30% más de vida máxima',
  'life_0_6': '+5% de aumento en la vida máxima',
  'life_0_7': '+5% de resistencia física y putrefacción',
  'life_0_8': '+7% de resistencia física y putrefacción · +7% de resistencia elemental',
  'life_0_9': '+5% de aumento en la vida máxima',
  'life_0_10': '+5% de resistencia elemental',
  'life_0_11': '+30% más de vida máxima',
  'life_0_12': 'El aumento y bono de regeneración de vida también se aplican a la vida máxima · No puedes robar vida',
  'life_0_13': '+20% más de vida máxima · 10% menos de daño de acción',
  'life_0_14': '+1% de aumento en la vida máxima por nivel de vida',
  'life_0_15': '+10% más de vida máxima',

  'life_1_0': '+5% de resistencia física y putrefacción',
  'life_1_1': '+5% de resistencia elemental',
  'life_1_2': '+7% de resistencia física y putrefacción · +7% de resistencia elemental',
  'life_1_3': '+5% de resistencia física y putrefacción',
  'life_1_4': '+5% de resistencia elemental',
  'life_1_5': 'El 5% del daño absorbido por tus resistencias se recupera como vida',
  'life_1_6': '+5% de resistencia física y putrefacción',
  'life_1_7': '+5% de resistencia elemental',
  'life_1_8': '+7% de resistencia física y putrefacción · +7% de resistencia elemental',
  'life_1_9': '+5% de resistencia física y putrefacción',
  'life_1_10': '+5% de resistencia elemental',
  'life_1_11': 'Los efectos de reducción de resistencia aplicados a ti pierden 50% de efectividad',
  'life_1_12': '+7% de resistencia física y putrefacción · -7% de resistencia elemental',
  'life_1_13': '+7% de resistencia elemental · -7% de resistencia física y putrefacción',
  'life_1_14': '+7% a todas las resistencias · 10% menos de vida máxima',
  'life_1_15': '+15% a todas las resistencias · No puedes robar vida',

  'life_2_0': '+5% de aumento en la regeneración de vida',
  'life_2_1': '+5% de aumento en la regeneración de vida',
  'life_2_2': '+12% de aumento en la regeneración de vida',
  'life_2_3': '+5% de aumento en la regeneración de vida',
  'life_2_4': '+5% de aumento en la regeneración de vida',
  'life_2_5': '+0,3% de la vida máxima regenerada por segundo',
  'life_2_12': 'Regeneración de vida duplicada · 30% menos de vida máxima robada por impacto',
  'life_2_13': 'Regeneración de vida duplicada · -5% a todas las resistencias',

  'life_3_0': 'Roba +0,5% del daño de impacto de acción como vida',
  'life_3_1': '+5% de aumento en la vida robada',
  'life_3_2': '+10% de aumento en el límite de robo de vida',
  'life_3_3': 'Roba +0,5% del daño de impacto de acción como vida',
  'life_3_4': '+5% de aumento en la vida robada',
  'life_3_5': 'Robar vida tiene 1% de probabilidad de activar Frenesí Voraz',
  'life_3_12': '+30% más de vida máxima robada por impacto · No puedes regenerar vida',
  'life_3_13': 'Puedes robar vida del daño de aflicción',

  'mana_0_0': '+5% de aumento en el maná máximo',
  'mana_0_1': '+2% de aumento en el maná máximo · +2% de aumento en la regeneración de maná',
  'mana_0_2': '+12% de aumento en el maná máximo',
  'mana_0_3': '+5% de aumento en el maná máximo',
  'mana_0_4': '+2% de aumento en el maná máximo · +2% de aumento en la regeneración de maná',
  'mana_0_5': '+20% más de maná máximo',
  'mana_0_6': '+5% de aumento en el maná máximo',
  'mana_0_7': '+2% de aumento en el maná máximo · +2% de aumento en la regeneración de maná',
  'mana_0_8': '+15% de aumento en el maná máximo · +5% de aumento en la regeneración de maná · +5% de aumento en la velocidad de acción',
  'mana_0_9': '+5% de aumento en el maná máximo',
  'mana_0_10': '+2% de aumento en el maná máximo · +2% de aumento en la regeneración de maná',
  'mana_0_11': '+20% más de maná máximo · +3% más de vida máxima',

  'mana_1_0': 'El Escudo de Maná absorbe +5% del daño de impacto entrante',
  'mana_1_1': '5% de reducción en el costo de conversión del Escudo de Maná',
  'mana_1_2': 'El Escudo de Maná absorbe +10% del daño de impacto entrante',
  'mana_1_3': 'El Escudo de Maná absorbe +5% del daño de impacto entrante',
  'mana_1_4': '5% de reducción en el costo de conversión del Escudo de Maná',
  'mana_1_5': 'El Escudo de Maná ahora intercepta todas las fuentes de daño',
  'mana_1_6': 'El Escudo de Maná absorbe +5% del daño de impacto entrante',
  'mana_1_7': '5% de reducción en el costo de conversión del Escudo de Maná',
  'mana_1_8': 'El Escudo de Maná absorbe +10% del daño de impacto entrante',
  'mana_1_9': 'El Escudo de Maná absorbe +5% del daño de impacto entrante',
  'mana_1_10': '5% de reducción en el costo de conversión del Escudo de Maná',
  'mana_1_11': 'Tus resistencias reducen el costo de conversión del Escudo de Maná',

  'mana_2_0': '+5% de aumento en la regeneración de maná',
  'mana_2_1': '+5% de aumento en la regeneración de maná',
  'mana_2_2': '+12% de aumento en la regeneración de maná',
  'mana_2_3': '+5% de aumento en la regeneración de maná',
  'mana_2_4': '+5% de aumento en la regeneración de maná',
  'mana_2_5': '+10% de probabilidad de que una acción reponga maná en lugar de agotarlo',

  'mana_3_0': 'Roba +0,5% del daño de impacto de acción como maná',
  'mana_3_1': '+5% de aumento en el maná robado',
  'mana_3_2': '+10% de aumento en el límite de robo de maná',
  'mana_3_3': 'Roba +0,5% del daño de impacto de acción como maná',
  'mana_3_4': '+5% de aumento en el maná robado',
  'mana_3_5': 'Robar maná tiene 1% de probabilidad de activar Frenesí Voraz',

  'enemy_0_0': '+50% de probabilidad de generar un enemigo adicional',
  'enemy_0_1': '+25% de probabilidad de generar 2 enemigos adicionales',
  'enemy_0_2': '+1 aparición de enemigo garantizada',
  'enemy_0_3': '+50% de probabilidad de generar un enemigo adicional',
  'enemy_0_4': '+25% de probabilidad de generar 2 enemigos adicionales',
  'enemy_0_5': '+2 apariciones de enemigos garantizadas · Una aparición de enemigo es al menos fuerte',
  'enemy_0_6': '+50% de probabilidad de generar un enemigo adicional',
  'enemy_0_7': '+25% de probabilidad de generar 2 enemigos adicionales',
  'enemy_0_8': '+1 aparición de enemigo garantizada',
  'enemy_0_9': '+50% de probabilidad de generar un enemigo adicional',
  'enemy_0_10': '+25% de probabilidad de generar 2 enemigos adicionales',
  'enemy_0_11': '+2 apariciones de enemigos garantizadas · Una aparición de enemigo es al menos élite',

  'enemy_1_0': '+5% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_1': '+10% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_1_2': '+12% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_3': '+5% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_4': '+10% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_1_5': 'Una aparición de enemigo es al menos fuerte · Una aparición de enemigo es al menos élite',
  'enemy_1_6': '+5% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_7': '+10% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_1_8': '+12% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_9': '+5% de probabilidad de que un enemigo sea fuerte',
  'enemy_1_10': '+10% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_1_11': '+20% de probabilidad de que un enemigo sea fuerte · +20% de probabilidad de que un enemigo fuerte sea élite · +1 aparición de enemigo garantizada',

  'enemy_2_0': '+5% de probabilidad de que un enemigo élite se convierta en campeón',
  'enemy_2_1': '+5% de probabilidad de que un enemigo sea fuerte · +5% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_2_2': '+5% de probabilidad de que un enemigo sea fuerte · +5% de probabilidad de que un enemigo fuerte sea élite · +5% de probabilidad de que un élite se convierta en campeón',
  'enemy_2_3': '+5% de probabilidad de que un enemigo élite se convierta en campeón',
  'enemy_2_4': '+5% de probabilidad de que un enemigo sea fuerte · +5% de probabilidad de que un enemigo fuerte sea élite',
  'enemy_2_5': '+1% de probabilidad de que un enemigo campeón se convierta en jefe',

  'enemy_3_0': '+10% de probabilidad al matar de generar un enemigo adicional en la siguiente oleada',
  'enemy_3_1': '+10% de probabilidad al matar de generar un enemigo adicional en la siguiente oleada',
  'enemy_3_2': '15% más enemigos generados',
  'enemy_3_3': '+10% de probabilidad al matar de generar un enemigo adicional en la siguiente oleada',
  'enemy_3_4': '+10% de probabilidad al matar de generar un enemigo adicional en la siguiente oleada',
  'enemy_3_5': '20% más enemigos generados',

  'movement_0_0': '+5% de aumento en la velocidad de movimiento',
  'movement_0_1': '+5% de aumento en la velocidad de movimiento',
  'movement_0_2': '+12% de aumento en la velocidad de movimiento',
  'movement_0_3': '+5% de aumento en la velocidad de movimiento',
  'movement_0_4': '+5% de aumento en la velocidad de movimiento',
  'movement_0_5': '+15% más de velocidad de movimiento',
  'movement_0_6': '+5% de aumento en la velocidad de movimiento',
  'movement_0_7': '+5% de aumento en la velocidad de movimiento',
  'movement_0_8': '+12% de aumento en la velocidad de movimiento',
  'movement_0_9': '+5% de aumento en la velocidad de movimiento',
  'movement_0_10': '+5% de aumento en la velocidad de movimiento',
  'movement_0_11': 'Los efectos de ralentización de movimiento sobre ti tienen 50% menos de eficiencia',
  'movement_0_12': 'Tu primera acción después de moverte causa 10% más de daño',
  'movement_0_13': '1% más de daño de acción por acción consecutiva sin moverse, hasta 10%',
  'movement_0_14': 'Eres inmune a los efectos que ralentizan el movimiento',
  'movement_0_15': '+15% más de velocidad de movimiento',

  'movement_1_0': '+20% de probabilidad de ganar una carga de Dash cada segundo',
  'movement_1_1': '+10% de aumento en la distancia del Dash',
  'movement_1_2': '+30% de probabilidad de ganar una carga de Dash cada segundo · +10% de aumento en la distancia del Dash',
  'movement_1_3': '+20% de probabilidad de ganar una carga de Dash cada segundo',
  'movement_1_4': '+10% de aumento en la distancia del Dash',
  'movement_1_5': '+50% de probabilidad de ganar una carga de Dash cada segundo',
  'movement_1_12': 'El Dash puede tener una carga adicional · 20% menos de distancia del Dash',
  'movement_1_13': 'El Dash siempre intenta acercarse al enemigo más cercano, independientemente del rango de acción',

  'movement_2_0': '+25% de tu velocidad de movimiento usada para Kite cuando los enemigos están a menos de la mitad de tu rango de acción',
  'movement_2_1': '+25% de tu velocidad de movimiento usada para Kite cuando los enemigos están a menos de la mitad de tu rango de acción',
  'movement_2_2': '+5 a todas las resistencias mientras haces Kite',
  'movement_2_3': '+25% de tu velocidad de movimiento usada para Kite cuando los enemigos están a menos de la mitad de tu rango de acción',
  'movement_2_4': '+25% de tu velocidad de movimiento usada para Kite cuando los enemigos están a menos de la mitad de tu rango de acción',
  'movement_2_5': 'El Dash puede usarse para hacer Kite y alejarse de los enemigos',
  'movement_2_12': 'Kitea siempre mientras el objetivo esté a tu alcance, retrocediendo hasta el 90% de tu alcance de acción',
  'movement_2_13': '+5% de aumento en la velocidad de acción mientras haces Kite',

  'cold_0_0':  '+5% de aumento en el daño de frío',
  'cold_0_1':  '+3% de aumento en la velocidad de acción de frío',
  'cold_0_2':  '+5% de aumento en el daño de frío · +5% de aumento en la probabilidad de aplicar escarcha',
  'cold_0_3':  '+5% de aumento en el daño de frío',
  'cold_0_4':  '+3% de aumento en la velocidad de acción de frío',
  'cold_0_5':  '10% más de daño de frío',
  'cold_0_6':  '+5% de aumento en el daño de frío',
  'cold_0_7':  '+3% de aumento en la velocidad de acción de frío',
  'cold_0_8':  '+12% de aumento en el daño de frío',
  'cold_0_9':  '+5% de aumento en el daño de frío',
  'cold_0_10': '+3% de aumento en la velocidad de acción de frío',
  'cold_0_11': 'Los enemigos congelados reciben 20% más de daño de fuentes no frías',

  'cold_1_0':  '+5% de aumento en la probabilidad de aplicar escarcha',
  'cold_1_1':  '+3% de aumento en el ralentizamiento por escarcha',
  'cold_1_2':  '+5% de aumento en el ralentizamiento · +10% de aumento en la duración de la escarcha',
  'cold_1_3':  '+5% de aumento en la probabilidad de aplicar escarcha',
  'cold_1_4':  '+3% de aumento en el ralentizamiento por escarcha',
  'cold_1_5':  '+8% de aumento en el ralentizamiento · +20% de aumento en la duración de la escarcha',
  'cold_1_6':  '+5% de aumento en la probabilidad de aplicar escarcha',
  'cold_1_7':  '+3% de aumento en el ralentizamiento por escarcha',
  'cold_1_8':  '+15% de aumento en la probabilidad de aplicar escarcha',
  'cold_1_9':  '+5% de aumento en la probabilidad de aplicar escarcha',
  'cold_1_10': '+3% de aumento en el ralentizamiento por escarcha',
  'cold_1_11': '15% más de efecto de ralentización de escarcha',
  'cold_1_12': '+5% de ralentización de escarcha aumentada · 10% menos de duración de escarcha',
  'cold_1_13': '20% más de duración de escarcha',
  'cold_1_14': 'Los enemigos escarchados infligen 10% menos de daño',
  'cold_1_15': '+5% de ralentización de escarcha aumentada',

  'cold_2_0':  'Los enemigos abatidos escarchados tienen +5% de probabilidad de fracturarse',
  'cold_2_1':  'Daño de fractura aumentado en un 2% de la vida máxima del enemigo fracturado',
  'cold_2_2':  'Los enemigos abatidos escarchados tienen +8% de probabilidad de fracturarse · +20% de área de efecto de fractura aumentada',
  'cold_2_3':  'Los enemigos abatidos escarchados tienen +5% de probabilidad de fracturarse',
  'cold_2_4':  'Daño de fractura aumentado en un 2% de la vida máxima del enemigo fracturado',
  'cold_2_5':  'Los enemigos abatidos escarchados tienen +10% de probabilidad de fracturarse · daño de fractura aumentado en un 3% de la vida máxima del enemigo fracturado',

  'cold_3_0':  'La Armadura helada requiere 20 escarchas menos por carga',
  'cold_3_1':  '1% de daño recibido reducido por carga de Armadura helada',
  'cold_3_2':  '30% de probabilidad de ganar 2 cargas de Armadura helada en lugar de 1 · 20% de agotamiento de cargas más lento',
  'cold_3_3':  'La Armadura helada requiere 20 escarchas menos por carga',
  'cold_3_4':  '1% de daño recibido reducido por carga de Armadura helada',
  'cold_3_5':  'La Armadura helada puede tener 5 cargas máximas más',
}
